import { VerifyAuthorizationAsync, GetPermissionsAsync } from '@/services/AuthorizationService';
import store from '@/store';

export default function (routes, authRoute) {
  return routes.map((r) => {
    const route = { ...r };

    route.beforeEnter = async (to, from, next) => {
      if (await VerifyAuthorizationAsync(to.name)) {
        const permissions = await GetPermissionsAsync(to.name);
        store.commit('auth/setPermissions', permissions);
        next();
      } else {
        next(authRoute);
      }
    };
    return route;
  });
}
